import { render, staticRenderFns } from "./active-detail.vue?vue&type=template&id=1ff9dcfc&scoped=true&"
import script from "./active-detail.vue?vue&type=script&lang=js&"
export * from "./active-detail.vue?vue&type=script&lang=js&"
import style0 from "./active-detail.vue?vue&type=style&index=0&id=1ff9dcfc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff9dcfc",
  null
  
)

export default component.exports